export const send = ({formData, url}) => (dispatch) => {
    const csrfToken = document.head.querySelector("[name~=csrf-token][content]").content;

    dispatch({
        type: 'FORM_SENDING'
    });
    fetch(url, {
        headers: {
            "Accept": "application/json",
            "X-CSRF-Token": csrfToken
        },
        'method': 'POST',
        body: formData
    }).then(async (response) => {
        const data = await response.json();
        if (response.status === 200) {

            dispatch({ type: 'FORM_SENT' });

        } else if (response.status === 500) {
            alert(response.statusText);
        } else {
            let errorMessage = '';
            for (let error in data.errors) {
                errorMessage = data.errors[error][0];
                break;
            }
            alert(errorMessage);
        }
    })

}

